import { connect } from 'react-redux';

import {
  deleteBranch,
  closeDeleteBranchDialog,
  getDeleteBranchDialogSlice,
  getDeleteBranchDialogBranch,
} from 'src/redux/branches';
import { BucketState } from 'src/types/state';

import DeleteBranchDialog from '../components/dialogs/delete-branch-dialog';

const mapStateToProps = (state: BucketState) => {
  const { isOpen, isDeleting } = getDeleteBranchDialogSlice(state);
  const branch = getDeleteBranchDialogBranch(state);
  const branchName = branch ? branch.name : ''; // This should be more resiliant
  return { isOpen, branchName, isDeleting };
};

// @ts-ignore TODO: fix noImplicitAny error here
const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeDeleteBranchDialog()),
  onDelete: () => dispatch(deleteBranch()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteBranchDialog);
